export const fontBase = 16;
export default {
    fontTiny: `${10 / fontBase}rem`,
    fontSmall: `${12 / fontBase}rem`,
    fontBase: `${14 / fontBase}rem`,
    fontMedium: `${16 / fontBase}rem`,
    fontLarge: `${18 / fontBase}rem`,
    fontXLarge: `${20 / fontBase}rem`,
    fontWtLight: '300',
    fontWtNormal: '400',
    fontWtMedium: '500',
    fontWtSemiBold: '600',
    fontWtBold: '700',
    fontWtExtraBold: '800',
    fontWtBlack: '900',
    primaryFontFamily: 'Roboto,Helvetica, Arial, sans-serif;',
};
//# sourceMappingURL=font.js.map